import { useMemo } from "react";

// Palette cycled across the dynamic status cards (Home-style solid cards).
const CARD_COLORS = [
  "bg-jiored1",
  "bg-jioyellow50",
  "bg-jiogreen1",
  "bg-jiojbm50",
  "bg-gray-500",
  "bg-yellow-500",
  "bg-teal-600",
  "bg-indigo-500",
];

export const ScoresForEng = ({
  tickets = [],
  status = [],
  mode,
  user,
  filter,
  setFilter,
  startDate,
  endDate,
}) => {
  // One card per canonical status from the DB (drop entries that are an alias of another).
  const statusTiles = useMemo(() => {
    const aliased = new Set();
    status.forEach((s) => (s.aliases || []).forEach((a) => aliased.add(a)));
    return status.filter((s) => !aliased.has(s.key));
  }, [status]);

  const list = useMemo(() => {
    let l = tickets;
    if (mode === "tasks") l = l.filter((t) => t.assign && t.assign.split("@")[0] === user);
    else if (mode === "tickets") l = l.filter((t) => t.createdBy && t.createdBy.split("@")[0] === user);

    if (startDate || endDate) {
      l = l.filter((t) => {
        const d = new Date(t.createdAt);
        if (isNaN(d.getTime())) return false;
        if (startDate && d < new Date(startDate)) return false;
        if (endDate) { const e = new Date(endDate); e.setHours(23, 59, 59, 999); if (d > e) return false; }
        return true;
      });
    }
    return l;
  }, [tickets, mode, user, startDate, endDate]);

  const counts = useMemo(() => {
    const c = { "": list.length }; // Total = all tickets, like Home
    statusTiles.forEach((s) => {
      c[s.key] = list.filter((t) => t.stageName === s.key).length;
    });
    return c;
  }, [list, statusTiles]);

  // Total first (like Home), then one card per status from the DB.
  const tiles = [
    { key: "", label: "Total", fill: "bg-jioskyblue53" },
    ...statusTiles.map((s, i) => ({
      key: s.key,
      label: s.key,
      fill: CARD_COLORS[i % CARD_COLORS.length],
    })),
  ];

  return (
    <div className="p-2 rounded-3xl">
      <div className="flex gap-1 m-3 mb-0 items-center justify-center">
        <p className="mr-auto text-2xl font-black tracking-tight leading-snug">
          Tickets Summary
        </p>
      </div>
      <div className="flex flex-wrap justify-center items-stretch gap-3 px-2 py-3">
        {tiles.map((tile) => {
          const selected = filter === tile.key;
          const count = counts[tile.key] || 0;
          return (
            <button
              key={tile.key + tile.label}
              onClick={() => setFilter(selected ? "" : tile.key)}
              className={`flex-1 min-w-[110px] flex flex-col justify-center rounded-xl px-4 py-3 text-white transition-all ${tile.fill} ${
                selected
                  ? "ring-4 ring-jiojbm30 shadow-lg scale-[1.03]"
                  : "opacity-95 hover:opacity-100 hover:shadow-md"
              }`}
            >
              <span className="font-bold text-4xl leading-none">{count}</span>
              <span className="font-jio-var text-xs font-bold mt-2 whitespace-nowrap leading-tight">
                {tile.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
